import {request} from '@/api';

export namespace Schemas {
	export function preview(feed: number): Promise<object | null> {
		return request(`/schemas/${feed}/preview`);
	}

	export function ingest(feed: number): Promise<null> {
		return request(`/schemas/${feed}/ingest`, {
			method: 'POST',
		});
	}
}
